import React from 'react'
import { Box, Button, Flex, Text } from 'pcln-design-system'
import {
  CarsOutlineGreenOnGreen,
  FlightsOutlineGreenOnGreen
} from '@pcln/brand'
import { ChevronRight, Plus } from 'pcln-icons'
import generatePackageListingUrl from './helper/generatePackageListingUrl'
import { PackageSearchParamsType } from '../types'

function FlightIcon() {
  return (
    <Flex
      borderRadius="2xl"
      width="36px"
      height="36px"
      bg="highlight.light"
      justifyContent="center"
      alignItems="center"
      mr="-8px"
    >
      <FlightsOutlineGreenOnGreen size="22px" />
    </Flex>
  )
}
function PlusIcon() {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      borderRadius="2xl"
      width="13px"
      height="13px"
      bg="success.dark"
      style={{ zIndex: 2 }}
    >
      <Plus size="15px" color="text.lightest" />
    </Flex>
  )
}

function CarIcon() {
  return (
    <Flex
      ml="-6px"
      borderRadius="2xl"
      width="36px"
      height="36px"
      bg="highlight.light"
      justifyContent="center"
      alignItems="center"
    >
      <CarsOutlineGreenOnGreen size="22px" />
    </Flex>
  )
}

const AIR_CAR_PACKAGE = 'AC'

function fireOnBundleNowClick(packageSearchParams: PackageSearchParamsType) {
  const searchUrl = generatePackageListingUrl({
    ...packageSearchParams,
    packageTypeCode: AIR_CAR_PACKAGE
  })
  window.open(searchUrl)
}
export default function BundleHugWithBanner({
  packageSearchParams,
  onBundleNowClick
}: {
  packageSearchParams: PackageSearchParamsType
  onBundleNowClick: () => void
}) {
  return (
    <Flex
      height="100px"
      justifyContent={['unset', null, null, 'right']}
      mr={[0, null, null, 4]}
      mt={['15px', '10px', null, '-10px']}
      alignItems={['center']}
    >
      <Flex
        width={['100%', null, null, 'auto']}
        bg="background.lightest"
        borderRadius="xl"
        p={3}
        pr={[3, null, null, 5]}
        pt="30px"
        flexDirection={['column', null, null, 'row']}
        style={{ gap: '8px' }}
      >
        <Flex alignItems="center">
          <FlightIcon />
          <PlusIcon />
          <CarIcon />
          <Box ml={2} mr={3}>
            <Flex
              bg="highlight.light"
              borderRadius="2xl"
              p={0}
              justifyContent="center"
              alignItems="center"
              width="102px"
              height="20px"
              mb={1}
            >
              <Text color="success.dark" bold fontSize="10px">
                BUNDLE & SAVE
              </Text>
            </Flex>
            <Text color="highlight.dark" textStyle="caption">
              Book your flight with a rental car and get extra savings!
            </Text>
            <Text color="highlight.dark" textStyle="caption">
              Save an average of $240 per person.
            </Text>
          </Box>
        </Flex>

        <Flex justifyContent="center" alignItems="center">
          <Button
            type="button"
            size="small"
            variation="subtle"
            color="primary.base"
            width={1}
            onClick={() => {
              onBundleNowClick()
              fireOnBundleNowClick(packageSearchParams)
            }}
            IconRight={ChevronRight}
          >
            <Text textStyle="captionBold">Bundle Now</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}
